import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getRoles } from 'pc-sales/store/actions/user';
import * as intl from 'react-intl-universal';

type uType = 'admin' | 'sales' | 'client' | 'ib';

interface iConfig {
    types: Array<uType>;
    extra?: boolean;
    tree?: boolean;
}

interface iRole {
    value: string;
    label: string;
    text: string;
    tag: string;
    type: string;
    id: string;
    role_name: string;
    children: Array<Partial<iRole>>;
}

const mapStateToProps = (state: any) => ({
    roles: state.user.get('roles').toJS(),
});

const mapDispatchToProps = (dispatch: any) => ({
    ...bindActionCreators({
        getRoles: getRoles.init,
    }, dispatch),
});

export default ({
                    types,
                    extra = false,
                    tree = false,
                }: iConfig) => (WrapperComponent: React.ComponentClass<any>): any => {
    @(connect(mapStateToProps, mapDispatchToProps) as any)
    class Service extends React.Component<any, any> {
        static defaultProps = {
            roles: {},
            authorities: {},
        };

        // 默认角色大类
        private static get roles(): Array<Partial<iRole>> {
            return [{
                value: 'client',
                label: intl.get('Global.Client'),
            }, {
                value: 'ib',
                label: intl.get('Global.Agent'),
            }, {
                value: 'admin',
                label: intl.get('Global.Admin'),
            }, {
                value: 'sales',
                label: intl.get('Global.Sales'),
            }];
        }

        private mounted: boolean;
        state: any = {
            roleList: [],
            roleMap: {},
            roleTree: [],
            isLoaded: false,
            roles: [],
        };

        componentDidMount() {
            this.mounted = true;
            this.isLoaded() ? this.initData() : this.props.getRoles({
                utype: types.join(','),
            }, {
                succeeded: this.initData,
                failed: this.mounted && this.setState({ isLoaded: true }),
            });
        }

        componentDidUpdate(prevProps: any) {
            if (prevProps?.roles !== this.props?.roles) {
                this.setState({ roles: this.props?.roles }, this.initData);
            }

        }

        componentWillUnmount() {
            this.mounted = false;
        }

        /**
         * 角色树列表
         * @param list
         */
        getTree = (list: iRole[]) => {
            const roleMap: Record<string, iRole[]> = list.reduce(
                (s: any, { type, text, value }: iRole) => ({
                    ...s,
                    [type]: [...(s[type] || []), { value, label: text, title: text }],
                }),
                {},
            );
            return Service.roles
                .map(({ value, label }: iRole) => ({ children: roleMap[value], value, label, title: label }))
                .filter((item) => item && item.children && item.children.length);
        };

        /**
         * 角色哈希表
         * @param list
         */
        getMap = (list: Array<Partial<iRole>>) => list.reduce((prev: Partial<iRole>, {
            text,
            value,
        }: Partial<iRole>) => ({
            ...prev,
            [value]: text,
        }), {});

        /**
         * 格式化角色列表
         * @param roles
         */
        getList = (roles: iRole) => Object.entries(roles)
            .filter(([key]: Array<uType>) => types.includes(key))
            .reduce((prev: Array<iRole>, [type, { data }]: Array<any>) => prev.concat(data.map((
                {
                    role_name,
                    id,
                    tag,
                }: Partial<iRole>) => ({
                text: role_name,
                value: id,
                type,
                tag,
            }))), []);

        /**
         * 初始化
         */
        initData = () => {
            const { roles } = this.state; // 使用 state 中的最新 roles
            const roleList = this.getList(this.props.roles || roles || []); // 格式化角色列表
            const state = { roleList } as any;
            if (extra) state.roleMap = this.getMap(roleList); // 添加哈希列表
            if (tree) state.roleTree = this.getTree(roleList); // 添加树形列表
            this.mounted &&
            this.setState(state, () => {
                this.setState({
                    isLoaded: true,
                });
            });
        };

        /**
         * 是否需要调用接口
         * @returns {boolean}
         */
        isLoaded = () => {
            const keys = Object.keys(this.props.roles || this?.state?.roles);
            return types.reduce((prev: boolean, curr: string) => prev && keys.includes(curr), true);
        };

        render() {
            const { roles: rolesFromProps, ...propRest } = this.props;
            const { roles: rolesFromState, ...stateRest } = this.state;
            const props = {
                ...propRest,
                ...stateRest,
                roles: Object.keys(rolesFromProps || {}) ? rolesFromProps : rolesFromState,

            };
            return <WrapperComponent {...props} />;
        }
    }

    return Service;
};
